import { styled } from '@mui/material';
import { useRef } from 'react';

import { useQuerySimpleStatistics, WidgetStatisticsContent } from '#features';
import { Loader } from '#shared';

import { Widget } from '../base';

import type { WidgetConfigBase, WidgetProps } from '#features';

type Settings = Record<string, never>;
const config: WidgetConfigBase<Settings> = {};

const Root = styled(Widget)(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '100%',
}));

export const WidgetStatistics = ({ instance }: WidgetProps<Settings>) => {
  const { data: statistics, isLoading } = useQuerySimpleStatistics();
  const showLoader = isLoading || !statistics;

  const ref = useRef<HTMLDivElement>(null);

  return (
    <Root ref={ref} config={config} instance={instance}>
      {() => (showLoader ? <Loader /> : <WidgetStatisticsContent />)}
    </Root>
  );
};

WidgetStatistics.config = config;
